/* -----------------Globals--------------- */
import { StatusBar } from "expo-status-bar";
import { useMemo } from "react";

import theme from "@configs/theme";
/* -----------------UI--------------- */
import { PaperProvider } from "react-native-paper";

/* -----------------Helpers & Hooks--------------- */
import { useThemeContext } from "@contexts/ThemeContext";
import { useAilaStore } from "@features/session/hooks/useAilaStore";
import { useQASearch } from "@features/session/hooks/useQASearch";
import { isIOS } from "@memorang/helpers/platform";

/* -----------------Types--------------- */
import type { ThemeProp } from "react-native-paper/lib/typescript/types";

import { pageViewTypes } from "@constants/tracking";
import { useAuthContext } from "@features/auth/contexts/AuthContext";
import useAnalytics from "@hooks/useAnalytics";
import { useAppStore } from "@hooks/useAppStore";
import { AiLAMobile } from "@memorang/features/src/qa-search/AiLAMobile";

const Modal = () => {
	const { isDarkMode } = useThemeContext();

	const finalTheme = theme(isDarkMode);
	const { userLogicalId } = useAuthContext();
	const { examId, contextId, handleTracking, feedbackDialogParams, examName } =
		useQASearch();

	const memoizedAnalyticsParams = useMemo(() => {
		return {
			type: pageViewTypes.aila,
		};
	}, []);
	useAnalytics(memoizedAnalyticsParams);
	const itemId = useAilaStore((state) => state.itemId);
	const selectedQuery = useAilaStore((state) => state.selectedQuery);
	const updateSelectedQuery = useAilaStore(
		(state) => state.updateSelectedQuery,
	);
	const userPrompt = useAilaStore((state) => state.userPrompt);
	const cacheIdentity = useAilaStore((state) => state.cacheIdentity);
	const isItemAnswered = useAilaStore((state) => state.isItemAnswered);
	const originalQuestionData = useAilaStore(
		(state) => state.originalQuestionData,
	);

	const aiAssistant = useAppStore((store) => store.app.aiAssistant);
	const appId = useAppStore((store) => store.app.id);

	return (
		<PaperProvider theme={finalTheme as unknown as ThemeProp}>
			{/* Native modals have dark backgrounds on iOS, set the status bar to light content. */}
			{isIOS && <StatusBar style="light" />}
			<AiLAMobile
				defaultQuery={selectedQuery.length > 0 ? selectedQuery : undefined}
				vectorStoreParams={{
					examId,
					itemId,
					contextId,
				}}
				handleResetDefaultQuery={() => updateSelectedQuery("")}
				userId={userLogicalId!}
				context={examName}
				handleTracking={handleTracking}
				feedbackDialogParams={feedbackDialogParams}
				key={itemId}
				userPrompt={userPrompt}
				cacheIdentity={cacheIdentity}
				isItemAnswered={isItemAnswered}
				originalQuestionData={originalQuestionData}
				assistantInfo={aiAssistant}
				appId={appId}
			/>
		</PaperProvider>
	);
};

export default Modal;
